// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__213Dn","label":"styles_label__7YoUC"};